import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
import { useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

import { fetch_all_with_count, fetch_all } from "../../lib/v31lib";
import { loginAtom } from '../../lib/auth';

import Lenis from "lenis";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";

import {
  Box,
  Grid,
} from '@mui/material';

import {
  Benefit,
  Cta,
  Footer,
  Hero,
  InputButton,
  NewsItem,
  Section,
  Waitlist,
  WhiteSection
} from '../../components/v2/custom';
import {
  Benefit as SkelBenefit,
} from '../../components/v2/skeleton';
import {
  Page,
  Pagination,
  TransparentButton,
  Typography
} from '../../components/v2/styled';

// import { Benefit as Ben } from '../../models/Benefit';
import { NewsItem as NI } from '../../models/NewsItem';
// import { User, loginFields } from '../../models/User';

// const { DateTime } = require("luxon");

type Props = {}

export const News: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  const [currentFilter, setCurrentFilter] = useState<number>(0);
  const [currentSearch, setCurrentSearch] = useState<string>('');
  const [currentSearchInput, setCurrentSearchInput] = useState<string>('');
  const [page, setPage] = useState<number>(0);
  let count = 0;

  const {
    data: news,
    isLoading: newsLoading,
    // isError: adviceUploadsError,
    isSuccess: newsSuccess,
    // refetch: adviceUploadsRefetch,
  } = useQuery({
    queryKey: ["nw", "news", page, {search: currentSearch, filter: currentFilter}],
    queryFn: () =>
      fetch_all_with_count<NI>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/fetch_all`,
        {
          object: 'v2_news',
          fields: ['id', 'created_at', 'subject', 'get_item', 'teaser', 'tag|id/name'],
          per_page: 9,
          page: page,
          order: 'weight DESC',
          filter: {
            advanced: {
              is_hidden: 0,
              enabled: 1,
              tag_id: currentFilter,
              catch_all: currentSearch,
              for_lang: i18n.resolvedLanguage || 'nl'
            }
          }
        },
        undefined
      ),
    select: (d) => {
      count = d.count;
      return d.result;
    },
    // enabled: false,
  });
  const {
    data: newsTags,
    // isLoading: benefitsLoading,
    // isError: adviceUploadsError,
    isSuccess: newsTagsSuccess,
    // refetch: adviceUploadsRefetch,
  } = useQuery({
    queryKey: ["nw", "news_tags"],
    queryFn: () =>
      fetch_all<{id: number, name: {[s:string]:string}}>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/fetch_all`,
        {
          object: 'v2_news_tag',
          fields: ['id', 'name'],
          per_page: 1000,
          page: page,
          order: 'weight DESC, name ASC',
        },
        undefined
      ),
    // enabled: false,
  });







  
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const lenis = new Lenis({
      // duration: 2,
    });
    lenis.on("scroll", ScrollTrigger.update);

    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  return <Page>
    <Hero
      children={<>
        <Typography variant="h1" sx={{
          maxWidth: {
            xs: '100%',
            lg: '670px'
          },
          textAlign: 'center',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}>{t("nw.news.hero.title")}</Typography>
        <Typography variant="subtitle1" sx={{
          color: theme.palette.primary.dark,
          marginTop: 4,
          maxWidth: {
            xs: '100%',
            lg: '670px'
          },
          textAlign: 'center',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}>{t("nw.news.hero.subsection")}</Typography>
      </>}
    />

    <WhiteSection isTransparent sx={{
      "& > div > div": {
        padding: 0
      }
    }}>
      <Grid container spacing={2.5}>
        <Grid item xs={12} sx={{overflow: 'hidden', position: 'relative'}}>
          <Typography variant="h5" sx={{marginBottom: 1.25}}>{t("nw.news.filter.title")}</Typography>
        
          <TransparentButton
            id="btn_filter_all"
            label={t("nw.news.filters.all")}
            sx={{
              textTransform: 'uppercase',
              ...(currentFilter === 0 ? {
                backgroundColor: theme.palette.primary.light,
                fontWeight: 'bold'
              } : {}),
              marginRight: 1,
              marginBottom: 1,
              padding: "2px 8px",
              // paddingLeft: 1,
              // paddingRight: 1,
              minWidth: '24px'
            }}
            onClick={() => {
              setCurrentFilter(0);
            }}
          />
          {!!newsTagsSuccess && newsTags.map(tag => <TransparentButton
            id="btn_filter_all"
            label={(tag.name || {})[i18n.resolvedLanguage || 'nl']}
            sx={{
              textTransform: 'uppercase',
              ...(currentFilter === tag.id ? {
                backgroundColor: theme.palette.primary.light,
                fontWeight: 'bold'
              } : {}),
              marginRight: 1,
              marginBottom: 1,
              padding: "2px 8px",
              // paddingLeft: 1,
              // paddingRight: 1,
              minWidth: '24px'
            }}
            onClick={() => {
              setCurrentFilter(tag.id);
            }}
          />)}
        </Grid>

        {!!newsLoading && [0, 1, 2, 3, 4, 5, 6, 7, 8].map(i => <Grid item xs={12} md={6} lg={4}>
          <SkelBenefit />
        </Grid>)}
        {!newsLoading && newsSuccess && news.map(newsItem => <Grid item xs={12} md={6} lg={4}>
          <NewsItem newsItem={newsItem} sx={{
            minWidth: '99%',
            maxWidth: '99%'
          }} />
        </Grid>)}

        <Grid item xs={12}>
          <Pagination
            count={count}
            page={page}
            setPage={setPage}
          />
        </Grid>
      </Grid>
    </WhiteSection>

    <Section normalPage>
      <Waitlist />
    </Section>

    <Footer normalPage />
  </Page>;
}

